import { lazy } from "react";
const Wrapper = lazy(() => import("./CadBoxWrapper"));
const LoadingIndicator = lazy(() => import("@mui/material/CircularProgress"));
export const CadClickCadBoxComponents = {
    Wrapper,
    LoadingIndicator,
};
//# sourceMappingURL=CadClickCadBoxComponents.js.map